/**
 * Email Queue Helpers
 * Functions to queue emails for sending via Cloud Functions
 */

import { db } from './config';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Queue a welcome email to be sent
 * @param {string} email - User's email address
 * @param {string} displayName - User's display name
 * @returns {Promise<void>}
 */
export const queueWelcomeEmail = async (email, displayName) => {
  try {
    await addDoc(collection(db, 'mail'), {
      to: email,
      template: 'welcome',
      displayName: displayName || '',
      email: email,
      createdAt: serverTimestamp()
    });
    console.log('Welcome email queued for:', email);
  } catch (error) {
    console.error('Error queuing welcome email:', error);
    throw error;
  }
};

/**
 * Queue an onboarding completion email
 * @param {string} email - User's email address
 * @param {string} displayName - User's display name
 * @param {string} organizationName - Organization name
 * @param {string} primaryGoal - User's selected primary goal
 * @returns {Promise<void>}
 */
export const queueOnboardingCompletionEmail = async (
  email,
  displayName,
  organizationName,
  primaryGoal
) => {
  try {
    await addDoc(collection(db, 'mail'), {
      to: email,
      template: 'onboardingCompletion',
      displayName: displayName || '',
      organizationName: organizationName || '',
      primaryGoal: primaryGoal || '',
      createdAt: serverTimestamp()
    });
    console.log('Onboarding completion email queued for:', email);
  } catch (error) {
    console.error('Error queuing onboarding completion email:', error);
    throw error;
  }
};
